import { render } from "./AlumniLp.vue?vue&type=template&id=1a4c69de"
import script from "./AlumniLp.vue?vue&type=script&lang=js"
export * from "./AlumniLp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__